import { useEffect, useRef, useState } from "react"
import { hasRole, useFlags, useHub, useTags } from "../../../../core/Global"
import Job from "../models/Job"
import { TagCompact } from "../../base/models/TagItem"
import Icon from "../../../../components/base/Icon"
import { API_ROUTES } from "../../../../core/Constants"
import { FlagCompact } from "../../base/models/FlagItem"

interface IProps {
    flags?: boolean
    tags?: boolean
    job: Job
}

export default function JobAddTag(props: IProps) {

    const hub = useHub()
    const tagsBank = useTags()
    const flagsBank = useFlags()
    const [flags, flagsSet] = useState<FlagCompact[]>([])
    const [tags, tagsSet] = useState<FlagCompact[]>([])
    const [keyword, keywordSet] = useState<string>("")
    const searchBox = useRef<HTMLInputElement>(null)




    useEffect(() => {
        let flg: any[] = [];
        let tgs: any[] = [];
        if (props.flags && flagsBank) {
            flg = flagsBank
                .filter(f => !props.job.flagIds?.includes(f.id!))
                .filter(f => f.name?.toLowerCase().includes(keyword.toLowerCase()));
        }
        if (props.tags && tagsBank) {
            tgs = tagsBank
                .filter(f => !props.job.tagIds?.includes(f.id!))
                .filter(f => f.name?.toLowerCase().includes(keyword.toLowerCase()));
        }
        flagsSet(flg)
        tagsSet(tgs)
    }, [tagsBank, flagsBank, props.job, keyword])

    return (
        <>
            {
                (!props.job.isArchived || hasRole("EditArchivedJobs")) && tagsBank.filter(f => !props.job.tagIds?.includes(f.id)).length > 0 &&
                <div>
                    <a href="#" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start"
                        className="badge badge-secondary mb-1"
                        style={{
                            backgroundColor: "transparent",
                            border: "1px dashed rgb(206 206 211)"
                        }}
                        onClick={e => {
                            window.dataTableMenu();
                            setTimeout(() => {
                                searchBox.current?.focus()
                            }, 100);
                        }}
                    >
                        <Icon icon="plus" size={10} />
                        {
                            (props.job.tags?.length ?? 0) == 0 &&
                            <span className="ms-1 fs-9 fw-bold">
                                Add Tag
                            </span>
                        }
                    </a>
                    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px p-0 m-0" data-kt-menu="true">
                        <div>
                            <input type="textbox" ref={searchBox} className="form-control form-control-sm border-0"
                                placeholder="Search..." value={keyword} onChange={e => keywordSet(e.target.value)} />
                        </div>
                        <div className="scroll-y noscrollbar" style={{
                            maxHeight: 400
                        }}>

                            {
                                flags.length > 0 &&
                                <div className="menu-content fs-6 text-gray-900 fw-bold px-3 mb-2">
                                    Flags
                                </div>
                            }

                            {
                                flags.map((f, k) =>
                                    <div key={k} className="menu-item m-0">
                                        <a href="#" className="menu-link px-3"
                                            onClick={e => {
                                                e.preventDefault();
                                                hub.Post(API_ROUTES.Jobs + "addflag", {
                                                    jobId: props.job.id,
                                                    flagId: f.id
                                                }, res => {
                                                    keywordSet("")
                                                })
                                            }}
                                        >
                                            <Icon icon="flag" className="me-2" type="solid" color={f.color} />
                                            {f.name}
                                        </a>
                                    </div>
                                )
                            }

                            {
                                tags.length > 0 &&
                                <div className="menu-content fs-6 text-gray-900 fw-bold px-3 mb-2 mt-2">
                                    Tags
                                </div>
                            }

                            {
                                tags.map((f, k) =>
                                    <div key={k} className="menu-item m-0">
                                        <a href="#" className="menu-link px-3"
                                            onClick={e => {
                                                e.preventDefault();
                                                hub.Post(API_ROUTES.Jobs + "addtag", {
                                                    jobId: props.job.id,
                                                    tagId: f.id
                                                }, res => {
                                                    keywordSet("")
                                                })
                                            }}
                                        >
                                            <Icon icon="tag" className="me-2" type="solid" />
                                            {f.name}
                                        </a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}